import { VehicleType, VehicleTypeRow } from "./types";

/*---------------------------------------------------------------------------------------
    VEHICLE MODEL SEARCH
  -----------------------------------------------------------------------------------------*/

export const transformVehicleTypeRow = (res: any): VehicleTypeRow => {
  return {
    id: res.id,
    image: res.image,
    name: res.name,
    availability: res.availability,
    basePrice: res.basePrice,
    bodyCode: res.bodyCode,
    co2: res.co2,
    cylinderCapacity: res.cylinderCapacity,
    drivenWheels: res.drivenWheels ?? null,
    engine: res.engine,
    fuelType: res.fuelType ?? null,
    liters: res.liters,
    manufacturerCode: res.manufacturerCode,
    maximumPowerHp: res.maximumPowerHp,
    maximumPowerKw: res.maximumPowerKw,
    numberOfDoors: res.numberOfDoors,
    price: res.price,
    roofType: res.roofType,
    seats: res.seats,
    secondaryFuelType: res.secondaryFuelType,
    transmission: res.transmission ?? null,
    trimLevel: res.trimLevel,
    vehicleTypeCode: res.vehicleTypeCode,
    wheelbaseType: res.wheelbaseType,
    yearFrom: res.yearFrom ?? null,
    yearTo: res.yearTo ?? null,
  };
};

/*---------------------------------------------------------------------------------------
      VEHICLE TYPE CREATE/EDIT
  -----------------------------------------------------------------------------------------*/

export const transformVehicleType = (res: any): VehicleType => {
  return {
    id: res.id,
    jom: res.jom,
    image: res.image,
    name: res.name,
    availability: res.availability,
    basePrice: res.basePrice,
    bodyCode: res.bodyCode,
    co2: res.co2,
    cylinderCapacity: res.cylinderCapacity,
    drivenWheels: res.drivenWheels ?? null,
    engine: res.engine,
    fuelType: res.fuelType ?? null,
    liters: res.liters,
    manufacturerCode: res.manufacturerCode,
    maximumPowerHp: res.maximumPowerHp,
    maximumPowerKw: res.maximumPowerKw,
    numberOfDoors: res.numberOfDoors,
    price: res.price,
    roofType: res.roofType,
    seats: res.seats,
    secondaryFuelType: res.secondaryFuelType,
    transmission: res.transmission ?? null,
    trimLevel: res.trimLevel,
    vehicleTypeCode: res.vehicleTypeCode,
    wheelbaseType: res.wheelbaseType,
    axles: Array.isArray(res.axles) ? res.axles.map((a: any) => ({
      axlePosition: a.axlePosition,
      width: a.width ?? null,
      ratio: a.ratio ?? null,
      diameter: a.diameter ?? null,
    })) : [],
  };
};












